import { Fragment } from "react";
import TextContainer from "../text/TextContainer";
import TextArrayContainer from "../text/TextArrayContainer";
import BudgetTableContainer from "../text/BudgetTableContainer";
import CategoryBudgetTableContainer from "../text/CategoryBudgetTableContainer";

const ProposalReformulated = ({
  project,
  reformulationItems,
  reformulations,
}) => {
  return (
    <>
      <TextContainer label="Name of Community" content={project.community} />
      <TextContainer label="Address 1" content={project.community_address1} />
      <TextContainer label="Address 2" content={project.community_address2} />
      <TextContainer label="Province" content={project.province} />
      <TextContainer label="Country" content={project.country} />
      <TextContainer
        label="Community Contact Name"
        content={`${project.creator?.first_name} ${
          project.creator.other_names ? project.creator.other_names + " " : ""
        }${project.creator?.last_name}`}
      />
      <TextContainer
        label="Community Contact Email"
        content={project.creator?.email}
      />
      <TextContainer
        label="Community Contact Number"
        content={project.creator?.phone || "NA"}
      />
      <TextContainer
        label="PDO Contact Name"
        content={`${project.partners[0]?.first_name} ${
          project.partners[0]?.other_name
            ? project.partners[0]?.other_names + " "
            : ""
        }${project.partners[0]?.last_name}`}
      />
      <TextContainer
        label="PDO Contact Email"
        content={project.partners[0]?.email}
      />
      <TextContainer
        label="PDO Contact Number"
        content={project.partners[0]?.phone || "NA"}
      />
      <TextContainer
        label="Planned Start Date"
        content={new Date(project.planned_start_date).toDateString()}
      />
      <TextContainer
        label="Planned End Date"
        content={new Date(project.planned_end_date).toDateString()}
      />
      <TextContainer
        label="Currency"
        content={`${
          project.currency?.name + " (" + project.currency?.symbol + ")"
        }`}
      />{" "}
      {reformulations.length > 0 ? (
        <>
          {/* Main Content */}
          {reformulations.map((item, index) => (
            <Fragment key={index}>
              {reformulationItems.find((i) => i.value === item.name).type ===
              "html" ? (
                <TextContainer
                  label={item.rename}
                  content={
                    project[
                      reformulationItems.find((i) => i.value === item.name)
                        .value
                    ]
                  }
                  isHTML
                />
              ) : reformulationItems.find((i) => i.value === item.name).type ===
                "array" ? (
                <TextArrayContainer
                  label={item.rename}
                  content={
                    project[
                      reformulationItems.find((i) => i.value === item.name)
                        .value
                    ]
                  }
                />
              ) : reformulationItems.find((i) => i.value === item.name).type ===
                "text" ? (
                <TextContainer
                  label={item.rename}
                  content={
                    project[
                      reformulationItems.find((i) => i.value === item.name)
                        .value
                    ]
                  }
                />
              ) : reformulationItems.find((i) => i.value === item.name).type ===
                "budget" ? (
                <div className="w-full overflow-x-auto">
                  <BudgetTableContainer
                    label={item.rename}
                    content={
                      project[
                        reformulationItems.find((i) => i.value === item.name)
                          .value
                      ] || []
                    }
                  />
                </div>
              ) : reformulationItems.find((i) => i.value === item.name).type ===
                "category" ? (
                <div className="w-full overflow-x-auto">
                  <CategoryBudgetTableContainer
                    label={item.rename}
                    content={
                      project[
                        reformulationItems.find((i) => i.value === item.name)
                          .value
                      ] || []
                    }
                  />
                </div>
              ) : (
                <p>Done</p>
              )}
            </Fragment>
          ))}
        </>
      ) : (
        <>
          {/* Content */}

          <TextContainer
            label="Description"
            isHTML
            content={project.description}
          />
          <TextContainer isHTML label="Goal" content={project.aim} />
          <TextContainer isHTML label="Purpose" content={project.purpose} />
          <TextArrayContainer label="Activities" content={project.activities} />
          <TextArrayContainer
            label="Results"
            content={project.expected_results}
          />
          <TextArrayContainer label="Objectives" content={project.objectives} />
          <TextContainer
            isHTML
            label="Selected Indicators"
            content={project.selected_indicators}
          />
          <TextContainer
            isHTML
            label="Sustainability Plan"
            content={project.sustainability_plan}
          />
          <TextContainer
            isHTML
            label="Justification"
            content={project.justification}
          />
          <TextContainer
            isHTML
            label="Monitoring and Supervision"
            content={project.monitoring_supervision}
          />
          <TextContainer
            isHTML
            label="How this project helps address the issues of the GC26 & DC27"
            content={project.issues}
          />
          {/*  */}
          <TextContainer
            label="Target Group"
            content={project.stakeholder_target_group}
          />
          <TextContainer
            label="Male Beneficiaries"
            content={project.male_beneficiaries}
          />
          <TextContainer
            label="Female Beneficiaries"
            content={project.female_beneficiaries}
          />

          {/* Budget */}
          <div className="w-full overflow-x-auto">
            <BudgetTableContainer
              label="Budget"
              content={project.budget || []}
            />
          </div>

          {/* Budget */}
          <div className="w-full overflow-x-auto">
            <CategoryBudgetTableContainer
              label="Budget for Category"
              content={project.catBudget || []}
            />
          </div>
        </>
      )}
    </>
  );
};

export default ProposalReformulated;
